import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-toolbar w-100" }
const _hoisted_4 = { class: "d-flex gap-1 justify-content-end w-100 mb-2 mx-2" }
const _hoisted_5 = {
  class: "btn btn-primary ps-2 pe-3 py-3",
  type: "button"
}
const _hoisted_6 = { class: "svg-icon svg-icon-2 me-0" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Medkon ")
const _hoisted_8 = {
  class: "btn btn-success ps-2 pe-3 py-3",
  type: "button"
}
const _hoisted_9 = { class: "svg-icon svg-icon-2 me-0" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Medsos ")
const _hoisted_11 = {
  key: 0,
  class: "d-flex flex-wrap gap-2",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_12 = { style: {"width":"15rem"} }
const _hoisted_13 = { style: {"width":"12rem"} }
const _hoisted_14 = { style: {"width":"11rem"} }
const _hoisted_15 = {
  class: "d-flex align-items-center gap-2 mx-4 mt-3 mb-2 text-primary",
  style: {"font-size":"14px"}
}
const _hoisted_16 = { class: "d-flex align-items-center gap-2" }
const _hoisted_17 = { style: {"width":"11rem"} }
const _hoisted_18 = { style: {"width":"11rem"} }
const _hoisted_19 = { style: {"width":"11rem"} }
const _hoisted_20 = { class: "d-flex align-items-center position-relative" }
const _hoisted_21 = { class: "svg-icon position-absolute ms-6" }
const _hoisted_22 = {
  key: 1,
  class: "d-flex justify-content-end align-items-center w-100",
  "data-kt-customer-table-toolbar": "selected"
}
const _hoisted_23 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder me-5 ms-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "Pilih Semua")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-end align-items-center d-none",
  "data-kt-customer-table-toolbar": "selected"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder me-5" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "me-2",
      "data-kt-customer-table-select": "selected_count"
    }),
    /*#__PURE__*/_createTextVNode(" Selected ")
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-danger",
    "data-kt-customer-table-select": "delete_selected"
  }, " Delete Selected ")
], -1)
const _hoisted_26 = { class: "card-body pt-0" }
const _hoisted_27 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "d-flex gap-2" }
const _hoisted_30 = { style: {"font-size":"12px"} }
const _hoisted_31 = {
  key: 0,
  href: "#",
  class: "text-gray-600 text-hover-primary mb-1"
}
const _hoisted_32 = {
  key: 1,
  href: "#",
  class: "text-gray-600 text-hover-primary mb-1"
}
const _hoisted_33 = ["href"]
const _hoisted_34 = ["href"]
const _hoisted_35 = ["href"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-primary" })
], -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash text-danger" })
], -1)
const _hoisted_41 = [
  _hoisted_40
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_ExportCustomerModal = _resolveComponent("ExportCustomerModal")!
  const _component_AddCustomerModal = _resolveComponent("AddCustomerModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: "/berita/add" }, {
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr075.svg" })
                  ]),
                  _hoisted_7
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/berita/socmed-add",
              class: "ms-3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr075.svg" })
                  ]),
                  _hoisted_10
                ])
              ]),
              _: 1
            })
          ]),
          (_ctx.checkedNews.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_el_date_picker, {
                    placeholder: "Select a date",
                    name: "filterTanggal",
                    type: "datetimerange",
                    modelValue: _ctx.filterTanggal,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterTanggal) = $event)),
                    shortcuts: _ctx.filterTanggalShortcut,
                    onChange: _ctx.filterTanggalChange,
                    "start-placeholder": "Tanggal Awal",
                    "end-placeholder": "Tanggal Akhir",
                    "default-time": _ctx.defaultTime,
                    style: {"width":"100%"},
                    class: "me-1"
                  }, null, 8, ["modelValue", "shortcuts", "onChange", "default-time"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_el_select, {
                    filterable: "",
                    clearable: "",
                    modelValue: _ctx.modelSelect.source,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelSelect.source) = $event)),
                    placeholder: "Pilih Sumber",
                    onChange: _ctx.filterSourceChange,
                    onClear: _ctx.filterSourceChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSource, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.label,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange", "onClear"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.modelSelect.jenis_data,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelSelect.jenis_data) = $event)),
                    class: "form-control-custom",
                    placeholder: "Pilih Jenis Berita",
                    multiple: "",
                    "collapse-tags": "",
                    "collapse-tags-tooltip": "",
                    remote: "",
                    "remote-method": _ctx.getDataOptionsType,
                    onChange: _ctx.filterJenisDataChange,
                    onClear: _ctx.filterJenisDataChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataJenisData, (group) => {
                        return (_openBlock(), _createBlock(_component_el_option_group, {
                          key: group._id
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.checkSource(group?.source)?.label), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.types, (type) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: type.name,
                                label: type.name,
                                value: type.name
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_16, _toDisplayString(type.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "remote-method", "onChange", "onClear"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_el_select, {
                    filterable: "",
                    clearable: "",
                    modelValue: _ctx.modelSelect.account,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelSelect.account) = $event)),
                    placeholder: "Pilih Media",
                    remote: "",
                    "remote-method": _ctx.fetchMedia,
                    onChange: _ctx.filterMediaChange,
                    onClear: _ctx.filterMediaChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item?.nama,
                          label: item?.nama,
                          value: item?.nama
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "remote-method", "onChange", "onClear"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  (_ctx.role == 88 || _ctx.role == 1)
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 0,
                        filterable: "",
                        clearable: "",
                        modelValue: _ctx.author,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.author) = $event)),
                        placeholder: "Pilih Author",
                        onChange: _ctx.filterAuthorChange,
                        onClear: _ctx.filterAuthorChange,
                        class: "me-3",
                        "value-key": "username"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataUser, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item._id,
                              label: item.full_name,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange", "onClear"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.search) = $event)),
                      onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchItems())),
                      class: "form-control form-control-solid w-150px ps-15",
                      placeholder: "Cari Berita",
                      style: {"height":"42px"}
                    }, null, 544), [
                      [_vModelText, _ctx.search]
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.is_select_all) = $event)),
                    onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.checkAll && _ctx.checkAll(...args)))
                  }, null, 544), [
                    [_vModelCheckbox, _ctx.is_select_all]
                  ])
                ]),
                _hoisted_24,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger btn-sm ms-auto",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deleteSelectedNews()))
                }, " Hapus " + _toDisplayString(_ctx.checkedNews.length) + " Berita Terpilih ", 1)
              ])),
          _hoisted_25
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_Datatable, {
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true,
          key: _ctx.tableKey,
          total: _ctx.total_data,
          "rows-per-page": _ctx.itemsPerPage,
          "current-page": _ctx.currentPage,
          loading: _ctx.is_loading,
          onCurrentChange: _ctx.currentChange,
          onItemsPerPageChange: _ctx.itemsPerPageChange
        }, {
          "cell-checkbox": _withCtx(({ row: stream }) => [
            _createElementVNode("div", _hoisted_27, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                value: stream._id,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.checkedNews) = $event))
              }, null, 8, _hoisted_28), [
                [_vModelCheckbox, _ctx.checkedNews]
              ])
            ])
          ]),
          "cell-account": _withCtx(({ row: stream }) => [
            _createTextVNode(_toDisplayString(stream.account) + " " + _toDisplayString(stream.program && stream.program !== "-" && stream.program !== "" ? "- " +
            stream.program : ""), 1)
          ]),
          "cell-source": _withCtx(({ row: stream }) => [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.profileSource(stream.source).icon),
                style: _normalizeStyle(`color: ${_ctx.profileSource(stream.source).color}; font-size: 15px !important`)
              }, null, 6),
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.profileSource(stream.source).label), 1)
            ])
          ]),
          "cell-jenis_data": _withCtx(({ row: stream }) => [
            _createTextVNode(_toDisplayString(stream.jenis_data || '-'), 1)
          ]),
          "cell-title": _withCtx(({ row: stream }) => [
            (
            stream.source == 'instagram' ||
            stream.source == 'twitter' ||
            stream.source == 'tiktok' ||
            stream.source == 'threads'
          )
              ? (_openBlock(), _createElementBlock("a", _hoisted_31, _toDisplayString(stream.id_account), 1))
              : (_openBlock(), _createElementBlock("a", _hoisted_32, _toDisplayString(stream.title), 1))
          ]),
          "cell-author": _withCtx(({ row: stream }) => [
            _createTextVNode(_toDisplayString(stream.author), 1)
          ]),
          "cell-file_source": _withCtx(({ row: stream }) => [
            (stream.source == 'news')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  target: "__blank",
                  href: stream.file_source
                }, "Link", 8, _hoisted_33))
              : (
            stream.source == 'youtube' ||
            stream.source == 'instagram' ||
            stream.source == 'twitter' ||
            stream.source == 'facebook' ||
            stream.source == 'tiktok' ||
            stream.source == 'review' ||
            stream.source == 'threads'
          )
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    target: "__blank",
                    href: stream.url
                  }, "Link", 8, _hoisted_34))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(stream.file_source, (src, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createElementVNode("a", {
                        target: "__blank",
                        href: src
                      }, "File " + _toDisplayString(index + 1), 9, _hoisted_35)
                    ]))
                  }), 128))
          ]),
          "cell-date": _withCtx(({ row: stream }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(stream.date)), 1)
          ]),
          "cell-actions": _withCtx(({ row: stream }) => [
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.goToRoute(stream._id, 'berita-detail', true)),
              type: "button",
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
            }, _hoisted_38, 8, _hoisted_36),
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.deleteBerita(stream._id)),
              type: "button",
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
            }, _hoisted_41, 8, _hoisted_39)
          ]),
          _: 1
        }, 8, ["table-data", "table-header", "total", "rows-per-page", "current-page", "loading", "onCurrentChange", "onItemsPerPageChange"])
      ])
    ]),
    _createVNode(_component_ExportCustomerModal),
    _createVNode(_component_AddCustomerModal)
  ], 64))
}